import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import { generatePdf } from "./DailyReportPDF";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  base_url,Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";

import Dropdown from 'react-bootstrap/Dropdown';
const SupplychainPackagelistHeadersView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [valueHeader, setValueHeader] = useState({});
  const [valueContents, setValueContents] = useState([]);
    const [permission, setPermission] = useState({});
    const [invoicedata, setInvoicedata] = useState({});
  
      let season_id = localStorage.getItem("season_id");

  const [apiData, setApiData] = useState([]);
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  // const [pdfUrl, setPdfUrl] = useState("");
  // const [showGenerateButton, setShowGenerateButton] = useState(true);
  const [packagingid, setPackagingid] = useState(0);
  // const [existinvoice, setExistinvoice] = useState({});
  useEffect(() => {
        setPermission(FindModuleById(91)); 
console.log(permission);

    axios
      .get(`/supply-chain-packaging-list-header/view/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.supply_chain_header_items);
          setValueHeader(response.data.data.supply_chain_header);
          setValueContents(response.data.data.all_contents_details);
          setPackagingid(response.data.data.supply_chain_header_items.id)
          // setExistinvoice(response.data.data.exist_invoice)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const handleGenerateInvoice = () => {
    //loader-image-invoice3

    $("#loader-image-invoice3").removeClass('loader-hide');
    $("#loader-image-invoice3").addClass('loader-show');

    let season_id = localStorage.getItem("season_id");
    axios
      .get(`/invoices/generate/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          toast.success(response.data.message);
          setInvoicedata(response.data.data.invoice);
          // setPdfUrl(response.data.url);
          setInvoiceGenerated(true);
         // setShowGenerateButton(false); // Hide the "Generate Invoice" button

          // Get the generated invoice ID and fetch its details
          const invoiceId = response.data.data.invoice.id;
          console.log(invoiceId, "ID idhar hai");
          fetchInvoiceDetails(invoiceId);
          
          $("#loader-image-invoice3").addClass('loader-hide');
          $("#loader-image-invoice3").removeClass('loader-show');
        } else {
          toast.error(response.data.errors);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const fetchInvoiceDetails = (invoiceId) => {
    let season_id = localStorage.getItem("season_id");
    axios
      .get(`/invoices/view-download/${season_id+'-'+invoiceId}`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          console.log(response.data.data.invoice);
          setApiData(response.data.data.invoice);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  
  const handleDownload = async () => {
    let season_id = localStorage.getItem("season_id");
    $("#loader-image").removeClass('loader-hide');
    $("#loader-image").addClass('loader-show');
    axios.get(`/supply-chain-packaging-list-header/pdf/${season_id+'-'+id}`, {
       responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
   }).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = value.lot_number +'.pdf';
        link.download = file_name;
        link.click();
        $("#loader-image").addClass('loader-hide');
        $("#loader-image").removeClass('loader-show');
    })
    .catch(error => {
        console.error('Error downloading PDF:', error);
    });
};
  

   
const generatePdfInvoiceDownloadExcel = async (invoice) => {
  let season_id = localStorage.getItem("season_id");
     window.open(`${base_url}/invoices/view-download-excel-open/${season_id+'-'+invoice.id}`, '_blank');
}
  const generatePdfInvoiceDownload2 = async (invoice) => {
  let season_id = localStorage.getItem("season_id");
  $("#loader-image-invoice2").removeClass('loader-hide');
  $("#loader-image-invoice").addClass('loader-show');
  axios.get(`/invoices/view-download-pdf/${season_id+'-'+invoice.id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

          const po_order_number = invoicedata.po_order_number || '';
        const invoicenumber = invoicedata.invoice_number || '';
        const company_name = invoicedata.customer?.company_name || 'Unknown';
      
     let file_name = invoicenumber +" "+company_name+' '+po_order_number +'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image-invoice2").addClass('loader-hide');
      $("#loader-image-invoice2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
};

useEffect(() => {



}, [id]);
const downloadExcel = (packaging_idd) => {
  let season_id = localStorage.getItem("season_id");
  window.open(`${base_url}/supply-chain-packaging-list-header/excel-open/${season_id+'-'+packaging_idd.packagingid}`, '_blank');
}



  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title"> Packing List</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-package-lists">
                         Packing List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View  Packing List
                    </li>
                  </ul>
                </div>
                <div className="col-auto">
                  
                
                   <div style={{float:"right"}}>
                 
                  <span>
                                     
                    {value && invoiceGenerated === false && value.lot_number ?  (
                            <button
                              className="btn btn-primary me-1"
                              onClick={handleGenerateInvoice}
                            >
                              Generate Invoice  <img id="loader-image-invoice3" className="loader-image loader-hide" src={loader_image}/>  
                            </button>
                        ) : null}
                      {invoiceGenerated && (
                    <div>

                          <Dropdown>
                            <Dropdown.Toggle variant="primary" id="dropdown-basic1">
                              Download Invoice
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item id="save-close"  onClick={() =>  generatePdfInvoiceDownload2(apiData)}  >PDF <i className="fa fa-download" /> <img id="loader-image-invoice2" className="loader-image loader-hide" src={loader_image}/> </Dropdown.Item>
                              <Dropdown.Item id="save-new"   onClick={() => generatePdfInvoiceDownloadExcel(apiData)}  > EXCEL  <i className="fa fa-download"></i></Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>

                    </div>
                     
                   
                  )}
                    </span>
                   
{value && value.lot_number ?  (
   <Dropdown>
        <Dropdown.Toggle variant="primary" id="dropdown-basic">
          Download Packing List
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item id="save-close"  onClick={() => handleDownload()}  >PDF <i className="fa fa-download" /> <img id="loader-image" className="loader-image loader-hide" src={loader_image}/> </Dropdown.Item>
          <Dropdown.Item id="save-new"   onClick={() =>downloadExcel({packagingid})}  > EXCEL  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/></Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

) : null}
                         
                    </div>
                   
                  
                </div>
               
                
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">
                       Packing List Details
                    </h4>
                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">Lot Number</th>
                        <td className="p-3">{value.lot_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Expedition Date</th>
                        <td className="p-3">{value.expedition_date}</td>
                      </tr>

                      <tr>
                        <th className="p-3">Production Type</th>
                        <td className="p-3">
                          {valueHeader.productiontype
                            ? valueHeader.productiontype.title
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Order</th>
                        <td className="p-3">
                          {valueHeader.order_detail
                            ? valueHeader.order_detail.po_number
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">GGN Number</th>
                        <td className="p-3">{value.ggn_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">ETD</th>
                        <td className="p-3">{value.dat_of_loading}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Seal Number</th>
                        <td className="p-3">{value.seal_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Truck Number</th>
                        <td className="p-3">{value.truck_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Transport Company</th>
                        <td className="p-3">
                        {valueHeader.transport_supplier
                            ? valueHeader.transport_supplier.name
                            : ""}
                          </td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Net Weight</th>
                        <td className="p-3">{value.total_net_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Brut Weight</th>
                        <td className="p-3">{value.total_brut_weight}KG</td>
                      </tr>
                      <tr>
                        <th className="p-3">Remarks</th>
                        <td className="p-3">{value.remarks}</td>
                      </tr>
                    </table>
                    <br />
                    <h5 className="card-title">Contents</h5>
                    <br />


<table className="table table-bordered text-center">
  <thead>
    <tr>
      <th>Pallet Number</th>
      {valueHeader.production_type === 1 && <th>Production Output Pallet</th>}
      <th>Product</th>
       <th>Lot Number</th>
      <th>Caliber</th>
      {valueHeader.production_type === 2 && <th>Packaging Type</th>}
      <th>GGN Number</th>
      <th>No of Boxes</th>
      <th>Net Weight</th>
      <th>Gross Weight</th>
    </tr>
  </thead>
  <tbody>
    {valueContents.map((order_item, index) => (
      <tr key={order_item.pallet_number || index}>
        <td style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {order_item.pallet_number}
        </td>

        {valueHeader.production_type === 1 && (
          <td style={{ display: 'table-cell', verticalAlign: 'middle' }} className="pallet-product-out">
            <a href={`/production-output-view/${order_item.production_output_id}`} className="">
              {order_item.barcode_number}
            </a>
          </td>
        )}

        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.product_name}</p>
          ))}
        </td>
       
        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.lot_number}</p>
          ))}
        </td>
       
        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.calibre}</p>
          ))}
        </td>

        {valueHeader.production_type === 2 && (
          <td className="text-center">
            {order_item.products.map((prod) => (
              <p key={prod.id}>{prod.packaging_type_name}</p>
            ))}
          </td>
        )}

        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.ggn_number}</p>
          ))}
        </td>

        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.number_of_boxes}</p>
          ))}
        </td>

        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.net_weight}KG</p>
          ))}
        </td>

        <td>
          {order_item.products.map((prod) => (
            <p key={prod.id}>{prod.gross_weight}KG</p>
          ))}
        </td>
      </tr>
    ))}
  </tbody>
</table>

                  

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SupplychainPackagelistHeadersView;
